import type { ValueGetterParams } from 'ag-grid-community';
import { get } from 'lodash-es';
import { isNonEmpty } from '../../../../utils/string';
import type { BlotterTableContextProps } from '../../BlotterTableContext';
import { getStrikePriceValueFromSecurity } from './getStrikePriceValueFromSecurity';
import type { StrikeFwdPriceValue } from './strikeFwdPriceValue';

function getBlotterContextProps(context: unknown): BlotterTableContextProps | undefined {
  if (context && typeof context === 'object' && 'current' in context) {
    return (context as { current?: BlotterTableContextProps }).current;
  }
  return undefined;
}

/** Value for strike-price columns on position/PMS rows resolved via `securitiesBySymbol`. */
export function getStrikePriceColumnValue(
  params: ValueGetterParams,
  symbolField: string
): StrikeFwdPriceValue | undefined {
  const data = params.data;
  if (!data) {
    return undefined;
  }

  const symbol = get(data, symbolField);
  if (typeof symbol !== 'string' || !isNonEmpty(symbol)) {
    return undefined;
  }

  const blotterCtx = getBlotterContextProps(params.context);
  const security = blotterCtx?.securitiesBySymbol?.get(symbol);
  return getStrikePriceValueFromSecurity(security);
}
